<!--水电缴费明细页面  -->
<template>
  <div class="comReportDetails" v-wechat-title="titleText">
    <div class="header" @click="selectDate()">
       <div class="header_text">
         {{currentyear=='全部'?currentyear:currentyear+'年'}}
       </div>
       <img class="header_icon" :src="require('../../assets/images/icon_arrows_unfold.png')" alt="">
    </div>
    <div class="default" v-if="!monthFeeBillBeans.length" @click="getPropertyBill()">
      <no-message></no-message>
    </div>
    <div class="billList">
      <div :class="['billItem',item.open?'billItem_open':'']"  v-for="(item,index) in monthFeeBillBeans" :key="index">
        <div class="billItem_top">
          <div class="billItem_top_1">{{item.payDate}}</div>
          <div class="billItem_top_2">
            <div class="top_2_1">
              <span class="top_title">应付:</span>
              <span class="top_2_1t">¥{{item.planAmountTotal?item.planAmountTotal:0 | numberFilter}}</span>
            </div>
            <div class="top_2_2">
              <span class="top_title">实付:</span>
              <span class="top_2_2t">¥{{item.realAmountTotal?item.realAmountTotal:0 | numberFilter}}</span>
            </div>
            <div class="top_2_3" @click="openItem(index)">
              <span class="top_title">抄表期间</span>
              <img :class="['top_2_31',item.open?'top_2_31_open':'']" :src="require('../../assets/images/icon_arrows_unfold.png')" alt="">
            </div>
          </div>
        </div>
        <div class="billItem_bottom" v-for="(itemMin,indexMin) in item.feeBillBeans" :key="indexMin">
          <div class="billItem_bottom_l">{{itemMin.startDate}} 至 {{itemMin.endDate}}</div>
          <div class="billItem_bottom_r">¥{{itemMin.planAmount | numberFilter}}</div>
        </div>
      </div>
    </div>

    <!--时间选择  -->
    <mt-popup v-model="popupVisible" position="bottom" class="mint-popup">
      <mt-picker class="picker" :slots="slots" @change="onValuesChange" :visible-item-count="5" :show-toolbar="true" ref="picker">
        <div class="picker_wrap">
          <div class="picker_btn" @click="popupVisible=false">取消</div>
          <div class="picker_btn2" @click="handleConfirm">确认</div>
        </div>
      </mt-picker>
    </mt-popup>

  </div>
</template>

<script>
import util from '../../utils/util';
import NoMessage from '../../components/nomessage';
import {callSpaceUp} from '../../utils/api';
import { mapState } from 'vuex';
export default {
  name: 'billDetails',
  components: {
    NoMessage
  },
  computed: {
    ...mapState({
      common: state => state.common
    })
  },
  filters:{
    numberFilter(value){
      return value.toFixed(2)
    }
  },
  data () {
    return {
        titleText:'用电明细',
        /*
        * 历史用水明细
        */
        monthWaterBillBeans:[],
        /*
        * 历史用电明细
        */
        monthElectricBillBeans:[],

        monthFeeBillBeans:[],
        currentyear:"全部",
        popupVisible:false,
        slots: [
          {
            flex: 1,
            values: [],
            className: 'slot1',
            textAlign: 'center'
          }
        ]
    };
  },
  created () {
    let date = new Date();
    let year = date.getFullYear()
    let arr = ['全部']
    for(let i=0;i<20;i++){
      arr.push(year+i)
    }
    this.slots =  [
      {
        flex: 1,
        values:arr,
        className: 'slot1',
        textAlign: 'center'
      }
    ]
    // this.contractNo = this.$route.query.id
    // this.contNo = this.$route.query.contNo
    this.getPropertyBill();
  },
  methods: {
    /*
    * 确定选择年份
    */
    handleConfirm(){
      this.popupVisible = false;
      let valve = this.$refs.picker.getValues()[0];
      this.currentyear = valve
      this.getPropertyBill();
    },
    /*
    * 选择过滤年份
    */
    selectDate(){
      this.popupVisible = true;
    },
    /*
    * 年份选择框 变更
    */
    onValuesChange(picker, values) {
      if (values[0] > values[1]) {
        picker.setSlotValue(1, values[0]);
      }
    },
    /*
    * 切换展示抄表区间
    */
    openItem(index){
       for (let i = 0; i < this.monthFeeBillBeans.length; i++) {
         if(i==index){
           if(this.monthFeeBillBeans[i].open){
             this.monthFeeBillBeans[i].open = false
           }else{
             this.monthFeeBillBeans[i].open = true
           }
         }else{
           this.monthFeeBillBeans[i].open = false
         }
       }
    },
    /*
    * 获取水电明细
    */
    getPropertyBill() {
      let parmes = {
        contId:this.$route.query.id,
        year:this.currentyear=='全部'?'':this.currentyear,
        url: '/property/rstRepair/getPropertyBill'
      }
      console.log("合同水电详情parmes");
      console.log(parmes);
      callSpaceUp(parmes).then(res => {
        // console.log("合同水电详情");
        console.log(res);
        if (res.res.code == 10000) {
          let arr = []
          let len1 = res.body.data.monthElectricBillBeans?res.body.data.monthElectricBillBeans.length:0
          for(let j=0;j<len1;j++){
            res.body.data.monthElectricBillBeans[j].open = false
            arr.push(res.body.data.monthElectricBillBeans[j])
          }
          this.monthElectricBillBeans = arr

          let arr2 = []
          let len2 = res.body.data.monthWaterBillBeans?res.body.data.monthWaterBillBeans.length:0
          for(let j=0;j<len2;j++){
            res.body.data.monthWaterBillBeans[j].open = false
            arr2.push(res.body.data.monthWaterBillBeans[j])
          }
          this.monthWaterBillBeans = arr2
          /*
          *1 电费 2水费
          */
          if(this.$route.query.type == 1){
               this.monthFeeBillBeans = arr
               this.titleText = '用电明细'
          }else if(this.$route.query.type == 2){
               this.monthFeeBillBeans = arr2
               this.titleText = '用水明细'
          }
          console.log('this.monthFeeBillBeans')
          console.log(this.monthFeeBillBeans)
        }
      });
    },
  }
};
</script>
<style lang="less" scoped>
@import "../../assets/css/common.less";
.comReportDetails{
  background:#EDEDED;
  .header{
    width: 750px;
    height: 88px;
    background: #EDEDED;
    display: flex;
    align-items: center;
    justify-content: center;
    position: fixed;
    left: 0;
    top: 0;
    z-index: 2;
    .header_text{
      height:40px;
      font-size:28px;
      color:rgba(51,51,51,1);
      line-height:40px;
      margin-right: 8px;
    }
    .header_icon{
      width: 24px;
      height: 24px;
    }
  }
  .default{
    height: 100vh;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .billList{
    margin-top: 88px;
    .billItem{
      max-height: 160px;
      min-height: 160px;
      width: 750px;
      margin-bottom: 14px;
      background: #fff;
      overflow: hidden;
      transition: max-height ease-out 0.2s;
      .billItem_top{
        height: 160px;
        width: 750px;
        background: #fff;
        padding: 28px;
        box-sizing: border-box;
        .billItem_top_1{
          height:44px;
          font-size:32px;
          color:rgba(51,51,51,1);
          line-height:44px;
          margin-bottom: 20px;
        }
        .billItem_top_2{
          display: flex;
          align-items: center;
          .top_title{
            height:40px;
            font-size:24px;
            color:rgba(102,102,102,1);
            line-height:40px;
            margin-right: 8px;
            // margin:3px 8px 3px 0;
            display: inline-block;
          }
          .top_2_31{
            width: 24px;
            height: 24px;
            margin-left: 4px;
            transition:all .2s ease-in-out;
            transform: rotateZ(0deg);
          }
          .top_2_31_open{
            transform: rotateZ(-180deg);
          }
          .top_2_1{
            display: flex;
            align-items: center;
            margin-right: 48px;
            .top_2_1t{
              height:40px;
              font-size:28px;
              color:rgba(51,51,51,1);
              line-height:40px;
              display: inline-block;
            }
          }
          .top_2_2{
            display: flex;
            align-items: center;
            flex: 1;
            .top_2_2t{
              display: inline-block;
              height:40px;
              font-size:28px;
              color:rgba(252,63,86,1);
              line-height:40px;
            }
          }
        }
      }
      .billItem_bottom{
        height: 80px;
        background: #F8F8F8;
        width: 750px;
        display: flex;
        align-items: center;
        padding: 0 28px;
        box-sizing: border-box;
        border-bottom: 1px solid #EAEAEA;
        .billItem_bottom_l,.billItem_bottom_r{
          flex:1;
          font-size:24px;
          color:rgba(102,102,102,1);
          line-height:34px;
          text-align: left;
        }
        .billItem_bottom_r{
          text-align: right;
        }
      }
    }
    .billItem_open{
      max-height: 700px;
    }
  }
}
</style>
